export default __webpack_public_path__ + "post-fail.cfedc58cac0ca157a523ca39a29cd878.png";